import type { PropsWithChildren, ReactNode } from "react";
import React from "react";
import {
  createFeature,
  ThemeVersionProvider,
  useBrand,
} from "@edreamsodigeo/frontend-core";
import { PrismaProvider as MFEPrismaProvider } from "@edreamsodigeo/prisma-design-system";

import { HSA_DIAMOND_THEME_MOBILE } from "~/features";

const Provider = ({
  children,
  version,
}: PropsWithChildren<{ version: "cobalt" | "diamond" }>) => {
  const brand = useBrand();

  return (
    <ThemeVersionProvider version={version}>
      <MFEPrismaProvider version={version} brand={brand}>
        {children}
      </MFEPrismaProvider>
    </ThemeVersionProvider>
  );
};

const VersionedThemeVersionProvider = createFeature<{ children: ReactNode }>({
  name: HSA_DIAMOND_THEME_MOBILE,
  variations: [
    ({ children }) => <Provider version="cobalt">{children}</Provider>,
    ({ children }) => <Provider version="diamond">{children}</Provider>,
  ],
  version: 1,
});

export default VersionedThemeVersionProvider;
